import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaTransactions = React.lazy(() =>
    import('../NebulaTransactions')
);
const nebulaTransactionsRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_TRANSACTIONS_PAGE,
        element: <NebulaTransactions />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaTransactionsRoutesRegistry;
